module.exports = __webpack_public_path__ + "media/bg_video.9884c1c2.mp4";